"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButtonItem = exports.MenuButton = exports.MenuButtonItemVariations = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const solid_1 = require("@heroicons/react/solid");
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_components_icon_button_1 = __importDefault(require("@hydrogen/elements.ui.components.icon-button"));
const elements_ui_configs_1 = require("@hydrogen/elements.ui.configs");
const react_popper_1 = require("react-popper");
const themes_1 = require("./themes");
var MenuButtonItemVariations;
(function (MenuButtonItemVariations) {
    MenuButtonItemVariations["default"] = "default";
    MenuButtonItemVariations["danger"] = "danger";
})(MenuButtonItemVariations = exports.MenuButtonItemVariations || (exports.MenuButtonItemVariations = {}));
const AsLink = react_1.default.forwardRef(({ href = '', className, children }, ref) => {
    const Link = (0, elements_ui_configs_1.getLink)();
    return (react_1.default.createElement(Link, { to: href, className: className, ref: ref }, children));
});
const AsButton = react_1.default.forwardRef(({ onClick, className, children }, ref) => (react_1.default.createElement("button", { onClick: onClick, type: "button", className: className, ref: ref }, children)));
function MenuButtonItem(props) {
    const href = props.href || '#';
    const type = props.type ? props.type : 'default';
    const sharedClasses = themes_1.theme.menuButtonItem.shared;
    const activeClasses = themes_1.theme.menuButtonItem.states.active.layer;
    const typeClasses = themes_1.theme.menuButtonItem.types[type];
    const Tag = props.as === 'link' ? AsLink : AsButton;
    return (react_1.default.createElement(react_2.Menu.Item, null, ({ active }) => (react_1.default.createElement(Tag, { href: href, className: (0, elements_ui_utils_1.classNames)(active ? activeClasses : '', sharedClasses, typeClasses, 'w-full', props.className), onClick: props.onClick }, props.children))));
}
exports.MenuButtonItem = MenuButtonItem;
function MenuButton(props) {
    var _a;
    const [referenceElement, setReferenceElement] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const buttonText = props.buttonText || 'More options';
    const buttonIcon = props.icon || 'default';
    const { styles } = (0, react_popper_1.usePopper)(referenceElement, popperElement, { placement: 'bottom-start' });
    const buttonIcons = {
        default: solid_1.DotsHorizontalIcon,
        edit: solid_1.CogIcon,
    };
    const defaultButtonContent = (react_1.default.createElement(elements_ui_components_icon_button_1.default, { type: props.type, visual: true, size: props.size },
        react_1.default.createElement("span", { className: "sr-only" }, buttonText),
        react_1.default.createElement(elements_ui_icon_1.default, { icon: buttonIcons[buttonIcon], size: elements_ui_icon_1.IconsSizes.medium, className: "block" })));
    const buttonContent = props.buttonContent || defaultButtonContent;
    return (react_1.default.createElement(react_2.Menu, { as: "div", className: themes_1.theme.menuButton.container.layer },
        react_1.default.createElement(react_2.Menu.Button, Object.assign({ as: props.as, disabled: (_a = props.isDisabled) !== null && _a !== void 0 ? _a : false, ref: (e) => setReferenceElement(e), className: (0, elements_ui_utils_1.classNames)(elements_ui_utils_1.globalColorClasses.focus, props.isDisabled && elements_ui_utils_1.globalColorClasses.disabled, props.buttonClass) }, (props.buttonProps || {})), buttonContent),
        react_1.default.createElement(elements_ui_utils_1.TransitionHelper, { origin: props.origin, style: props.withPopper ? styles.popper : {}, ref: (e) => setPopperElement(e) },
            react_1.default.createElement(react_2.Menu.Items, { className: elements_ui_utils_1.globalColorClasses.focus }, props.children))));
}
exports.MenuButton = MenuButton;
//# sourceMappingURL=menu-button.js.map